/* eslint-disable import/prefer-default-export */
import {
	ATTRIBUTES as BASE_ATTRIBUTES,
	BAR_TIMER_ORIENTATIONS as BASE_BAR_TIMER_ORIENTATIONS,
	EVENTS as BASE_EVENTS,
	HEADER_LABELS as BASE_HEADER_LABELS,
	ROUND_ATTRIBUTES as BASE_ROUND_ATTRIBUTES,
	SCORE_TYPES as BASE_SCORE_TYPES,
} from '../baseGame.types';

/**
 * @typedef {import('../baseGame.types').BaseRoundOptions} BaseRoundOptions
 * @typedef {import('../baseGame.types').BaseGameOptions} BaseGameOptions
 * @typedef {import('../../gameFactory.types').ENGINES} EnginesType
 *
 * @typedef {object} AdventNodePartial
 * @property {string} [url]
 * @property {keyof typeof import('../../gameFactory.types').ENGINES | string} [engine]
 * @property {string} [name]
 * @property {string} [customerUnlockTime]
 * @property {boolean} [unlockTimeIsUTC]
 * @property {string} [text]
 * @property {string} [backgroundImg]
 * @property {string} [foregroundImg]
 * @property {string} [dateImg]
 * @property {string} [lockedImg]
 * @property {string} [completedImg]
 * @property {string} [badgeImg]
 * @property {boolean} [isLocked]
 * @property {boolean} [isCompleted]
 * @property {number} [selectedOptionId]
 * @property {string} [type]
 * @property {string} [gameId]
 * @property {any[]} [pages]
 * @property {any[]} [content]
 *
 * @typedef {object} AdventGamePartial
 * @property {boolean} [startOnCurrentDate]
 * @property {AdventNodeOptions[]} [nodes]
 * @property {Record<keyof typeof HEADER_LABELS, string>} [labels]
 *
 * @typedef {BaseGameOptions & AdventGamePartial} AdventGameOptions
 * @typedef {BaseRoundOptions & AdventNodePartial} AdventNodeOptions
 */

/**
 * @enum {typeof NODE_ATTRIBUTES[keyof typeof NODE_ATTRIBUTES]}
 */
export const NODE_ATTRIBUTES = Object.freeze({
	...BASE_ROUND_ATTRIBUTES,
	url: 'url',
	engine: 'engine',
	name: 'name',
	customerUnlockTime: 'customerUnlockTime',
	unlockTimeIsUTC: 'unlockTimeIsUTC',
	text: 'text',
	backgroundImg: 'backgroundImg',
	foregroundImg: 'foregroundImg',
	dateImg: 'dateImg',
	lockedImg: 'lockedImg',
	completedImg: 'completedImg',
	badgeImg: 'badgeImg',
});

/**
 * @enum {typeof ATTRIBUTES[keyof typeof ATTRIBUTES]}
 */
export const ATTRIBUTES = Object.freeze({
	...BASE_ATTRIBUTES,
	startOnCurrentDate: 'startOnCurrentDate',
	adventItems: 'adventItems',
	btnCloseGameText: 'btnCloseGameText',
	nodes: 'nodes',
});

/**
 * @enum {typeof HEADER_LABELS[keyof typeof HEADER_LABELS]}
 */
export const HEADER_LABELS = Object.freeze({
	...BASE_HEADER_LABELS,
	score: 'score',
});

/**
 * @enum {typeof BAR_TIMER_ORIENTATIONS[keyof typeof BAR_TIMER_ORIENTATIONS]}
 */
export const BAR_TIMER_ORIENTATIONS = Object.freeze({
	...BASE_BAR_TIMER_ORIENTATIONS,
});

/**
 * @enum {typeof SCORE_TYPES[keyof typeof SCORE_TYPES]}
 */
export const SCORE_TYPES = Object.freeze({
	...BASE_SCORE_TYPES,
});

/**
 * @enum {typeof EVENTS[keyof typeof EVENTS]}
 */
export const EVENTS = Object.freeze({
	...BASE_EVENTS,
});
